(() => {
  const configElement = document.querySelector('[data-mm-favorites-config]');
  if (!configElement || window.maaniFavoritesReady) return;
  window.maaniFavoritesReady = true;
  const config = JSON.parse(configElement.textContent);
  const key = 'veronneau.favorites.v1';
  const grid = document.querySelector('[data-mm-favorites-grid]');
  const empty = document.querySelector('[data-mm-favorites-empty]');
  const dialog = document.querySelector('.mm-drawer--favorites');
  const live = document.querySelector('[data-mm-favorites-live]');
  const warning = document.querySelector('[data-mm-favorites-warning]');
  let favorites = [];
  let generation = 0;
  const normalize = items => [...new Set(Array.isArray(items) ? items.filter(x => typeof x === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(x)) : [])];
  try { favorites = normalize(JSON.parse(localStorage.getItem(key) || '[]')); } catch { warning.hidden = false; }
  const base = config.root.endsWith('/') ? config.root : config.root + '/';
  function save() {
    try { localStorage.setItem(key, JSON.stringify(favorites)); }
    catch { warning.hidden = false; }
  }
  function sync() {
    document.querySelectorAll('[data-mm-favorite]').forEach(button => {
      const saved = favorites.includes(button.dataset.mmFavorite);
      button.hidden = false;
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', saved ? button.dataset.removeLabel : button.dataset.addLabel);
      const label = button.querySelector('[data-favorite-label]');
      if (label) label.textContent = saved ? config.savedShort : config.addShort;
    });
    document.querySelectorAll('[data-mm-open=favorites]').forEach(button => { button.hidden = false; button.classList.toggle('has-favorites', favorites.length > 0); });
    document.querySelectorAll('[data-mm-favorites-count]').forEach(count => { count.textContent = favorites.length; count.hidden = !favorites.length; });
    document.querySelector('[data-mm-favorites-total]').textContent = favorites.length ? '(' + favorites.length + ')' : '';
  }
  function make(tag, className, text) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text) element.textContent = text;
    return element;
  }
  function removeButton(handle, title) {
    const button = make('button', 'mm-favorite mm-favorites__remove');
    button.type = 'button';
    button.dataset.mmFavorite = handle;
    button.dataset.addLabel = config.addLabel.replace('__title__',title);
    button.dataset.removeLabel = config.removeLabel.replace('__title__',title);
    button.title = config.removeShort;
    const svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
    svg.setAttribute('viewBox','0 0 24 24'); svg.setAttribute('fill','none'); svg.setAttribute('stroke','currentColor'); svg.setAttribute('stroke-width','1.3'); svg.setAttribute('aria-hidden','true');
    const path = document.createElementNS('http://www.w3.org/2000/svg','path');
    path.setAttribute('d','m6 6 12 12M6 18 18 6');
    svg.append(path); button.append(svg); return button;
  }
  async function productCard(handle) {
    const card = make('article','mm-favorites__card');
    try {
      const response = await fetch(base + 'products/' + encodeURIComponent(handle) + '.js', {headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('unavailable');
      const product = await response.json();
      const link = make('a'); link.href = base + 'products/' + encodeURIComponent(handle);
      if (product.featured_image) {
        const image = make('img');
        const imageUrl = new URL(product.featured_image,location.origin);
        imageUrl.searchParams.set('width','600');
        image.src = imageUrl.href; image.alt = product.title; image.width = 300; image.height = 220; image.loading = 'lazy';
        link.append(image);
      }
      link.append(make('h3','',product.title));
      card.append(link);
      const price = new Intl.NumberFormat(document.documentElement.lang || 'fr-CA',{style:'currency',currency:config.currency}).format(product.price/100);
      card.append(make('p','mm-favorites__price',price));
      if (!product.available) card.append(make('p','mm-favorites__message',config.unavailable));
      card.append(removeButton(handle,product.title));
    } catch {
      const link = make('a'); link.href = base + 'products/' + encodeURIComponent(handle);
      link.append(make('h3','',handle.replaceAll('-',' '))); card.append(link);
      card.append(make('p','mm-favorites__message',config.error));
      card.append(removeButton(handle,handle.replaceAll('-',' ')));
    }
    return card;
  }
  async function render() {
    const version = ++generation;
    const handles = [...favorites];
    empty.hidden = handles.length > 0;
    grid.replaceChildren();
    grid.setAttribute('aria-busy',String(handles.length > 0));
    if (!handles.length) return;
    grid.append(make('p','mm-favorites__message',config.loading));
    const cards = [];
    for (let i=0;i<handles.length;i+=4) {
      cards.push(...await Promise.all(handles.slice(i,i+4).map(productCard)));
      if (version !== generation) return;
    }
    if (version !== generation) return;
    grid.replaceChildren(...cards);
    grid.setAttribute('aria-busy','false'); sync();
  }
  document.addEventListener('click',event => {
    const button = event.target.closest('[data-mm-favorite]');
    if (!button) return;
    event.preventDefault(); event.stopPropagation();
    const handle = button.dataset.mmFavorite;
    const saved = favorites.includes(handle);
    favorites = saved ? favorites.filter(x=>x!==handle) : [...favorites,handle];
    save(); sync(); live.textContent = saved ? config.removed : config.added;
    if (dialog.open) render().then(()=>dialog.querySelector('.mm-favorites__remove, [data-mm-close]')?.focus({preventScroll:true}));
  },true);
  document.addEventListener('maani:favorites-open',render);
  window.addEventListener('storage', event => {
    if (event.key !== key) return;
    try { favorites = normalize(JSON.parse(event.newValue || '[]')); sync(); if(dialog.open) render(); } catch {}
  });
  const main = document.querySelector('#page-content');
  if (main) new MutationObserver(records => {
    if (records.some(record=>[...record.addedNodes].some(node=>node.nodeType===1 && (node.matches('[data-mm-favorite]') || node.querySelector('[data-mm-favorite]'))))) sync();
  }).observe(main,{childList:true,subtree:true});
  sync();
})();
